function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M221.09 64a157.09 157.09 0 1 0 157.09 157.09A157.1 157.1 0 0 0 221.09 64Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 32
    },
    d: "M338.29 338.29 448 448"
  }));
};
export { SvgSearch as ReactComponent };
export default "data:image/svg+xml,%3csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3e %3ctitle/%3e %3cpath d='M221.09,64A157.09,157.09,0,1,0,378.18,221.09,157.1,157.1,0,0,0,221.09,64Z' style='fill:none;stroke:%23000;stroke-miterlimit:10;stroke-width:32px'/%3e %3cline style='fill:none;stroke:%23000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px' x1='338.29' x2='448' y1='338.29' y2='448'/%3e %3c/svg%3e";